
import React, { useEffect } from 'react'
import { RadioContainer } from '../../../commons'
import { HSNWarningType } from './StockItemsForm';
import { handleHsnSacCheckForStock } from '../../../../utils/invoiceGeneration/commonFunctions';


type RadioTypes = {
    id: string;
    name: string;
};

//Future purpose
// const CALCULATE_RADIO_OPTIONS: RadioTypes[] = [
//     {
//         id: "one_item_rate",
//         name: "One Item Rate",
//     },
//     {
//         id: "on_value",
//         name: "On Value",
//     },
// ];

const TAXABILITY_RADIO_OPTIONS: RadioTypes[] = [
    {
        id: "nil_Rated",
        name: "Nil Rated",
    },
    {
        id: "taxable",
        name: "Taxable",
    },
    {
        id: "unknown",
        name: "Unknown",
    },
    {
        id: "exempt",
        name: "Exempt",
    },

];
type AppProps = {
    taxRadioValue: string;
    formError: any;
    setTaxRadioValue: (data: string) => void;
    setFormError: (data: any) => void;
    setInputDetails: (data: any) => void;
    inputDetails:any;
    clientMappedHSNData:any;
    hsnWarning:HSNWarningType;
    setHsnWarning:React.Dispatch<React.SetStateAction<HSNWarningType>>;
}

const GstDetails = ({
    setTaxRadioValue,
    taxRadioValue,
    setInputDetails,
    inputDetails,
    setFormError,
    formError,
    clientMappedHSNData,
    hsnWarning,
    setHsnWarning
}: AppProps) => {
    useEffect(() => {
        handleHsnSacCheckForStock(inputDetails?.hsnSacNo, clientMappedHSNData, setHsnWarning, setFormError);
    }, [inputDetails?.hsnSacNo, clientMappedHSNData]);
 
    

    const handleSetTaxRadioValue = (value: string) => {
        setTaxRadioValue(value);
        if(value==="taxable"){
            setInputDetails((prev: any) => ({
                ...prev,
                taxability: "Taxable"
            }))
        }
    };

    const handleGstDetailsChange = (e: any) => {
        const Name = e.target.name;
        const Value = e.target.value;
        if (Name === 'sac') {
            const numericValue = Value ? parseInt(Value, 10) : undefined;
            if (numericValue !== undefined && !isNaN(numericValue)) {
                setInputDetails((prev: any) => ({
                    ...prev,
                    hsnSacNo: numericValue,
                }));
             
                handleHsnSacCheckForStock(numericValue, clientMappedHSNData,setHsnWarning, setFormError);
                setFormError((prev: any) => ({
                    ...prev,
                    hsnError: '',
                }));
            } else if (Value === '') {
                setInputDetails((prev: any) => ({
                    ...prev,
                    hsnSacNo: undefined,
                }));
                setFormError((prev: any) => ({
                    ...prev,
                    hsnError: '',
                }));
            }
            // if (Value>=0) {
            //     setInputDetails((prev: any) => ({
            //         ...prev,
            //         hsnSacNo: Value
            //     }))
            //     setFormError((prev: any) => ({
            //         ...prev,
            //         hsnError:'',
            //     }))
            // }
        }
        else if (Name === 'description') {
            setInputDetails((prev: any) => ({
                ...prev,
                hsnSacDetails: Value
            }))
        }
        else if(Name === "rate"){
            setInputDetails((prev: any) => ({
                ...prev,
                rate: Value
            }))
        }
    }
    return (

        <>
            <div className="col-md-10">
                <h4>GST Details:</h4>
                <div className="col-md-12">
                    <h4 style={{ fontSize: '14px' }}
                    >HSN/SAC Details:</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <form>
                                <div className="form-group mt-3">
                                    <div>
                                        <label htmlFor="SAC"
                                        >HSN/SAC*</label>
                                        <input
                                            type="number"
                                            className={`form-control ${!!formError.hsnError ? "error-border" : null}`}
                                            name="sac"
                                            value={inputDetails?.hsnSacNo}
                                            onChange={(e) => handleGstDetailsChange(e)}
                                            onWheel={event => event.currentTarget.blur()}
                                            onBlur={() => handleHsnSacCheckForStock(inputDetails?.hsnSacNo, clientMappedHSNData,setHsnWarning,setFormError)} 
                                        />
                                        {!!formError.hsnError && (
                                            <>
                                            <small className="text-danger">{formError.hsnError}</small>
                                            {!!hsnWarning?.hsnWarning && <br />}
                                            </>
                                        )}
                                          {!!hsnWarning?.hsnWarning && (
                                            <small className="" style={{color:'#be7e12'}}>{`NOTE: ${hsnWarning?.hsnWarning}`}</small>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                         
                       

                        <div className="col-md-6">
                            <form>
                                <div className="form-group mt-3">
                                    <div>
                                        <label htmlFor="DESCRIPTION"
                                        >HSN Description</label>
                                        <textarea
                                            className={`form-control`}
                                            name="description"
                                            value={inputDetails?.hsnSacDetails}
                                            onChange={(e) => handleGstDetailsChange(e)}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                     {/* future purpose */}

                    {/* <h4>Tax Details :</h4>
                    <div className='row'  style={{ marginTop: '20px' }}>
                        <div className="col-md-10">
                            <h6>Calculate Type :</h6>
                            <div className="mt-3 mb-4">
                                <RadioContainer
                                    optionsList={CALCULATE_RADIO_OPTIONS}
                                    handleSetRadioValue={handleSetCalculateRadioValue}
                                    radioValue={calculateRadioValue}
                                />
                            </div>
                        </div>
                    </div> */}
                    <div className='row'

                    >
                        {/* {Taxability} */}
                        <div className="col-md-8">
                            <h6>Taxability:</h6>
                            <div className="mt-3 mb-4">
                                <RadioContainer
                                    optionsList={TAXABILITY_RADIO_OPTIONS}
                                    handleSetRadioValue={handleSetTaxRadioValue}
                                    radioValue={taxRadioValue}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             {/* future purpose */}

            {/* <div className="row">
                <div className="col-md-4" style={{ marginTop: '40px' }}>
                    <div className="form-group">
                        <div className='date-picker-wraper mr-0'>
                            <Label className='m-0 p-0 w-100'>
                                <ReactDatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={startDate ? new Date(moment(`${startDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { handleStartDateChange?.(moment(e).format('YYYY-MM-DD')) }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name='dateOfInvoice'
                                    placeholderText='choose effective date'
                                    className='form-control'
                                    disabled
                                />
                                <span className="calender-icon" style={{ right: '30px', cursor: 'pointer' }}>
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* {Calculate Type} */}

        </>
    )
}

export default GstDetails;